import React, { useCallback, useState } from 'react';

export interface HoveredSegment {
  key: string;
  /** Pointer position in viewport pixels, for ChartTooltip. */
  x: number;
  y: number;
}

export interface HoveredSegmentState {
  hovered: HoveredSegment | null;
  /** Call from a segment's onMouseMove. */
  onMove: (key: string, event: React.MouseEvent) => void;
  /** Call from a segment's onMouseLeave. */
  onLeave: () => void;
}

/** Which segment of a chart the pointer is over, and where, for a ChartTooltip. */
export const useHoveredSegment = (): HoveredSegmentState => {
  const [hovered, setHovered] = useState<HoveredSegment | null>(null);
  const onMove = useCallback(
    (key: string, event: React.MouseEvent) => setHovered({ key, x: event.clientX, y: event.clientY }),
    [],
  );
  const onLeave = useCallback(() => setHovered(null), []);
  return { hovered, onMove, onLeave };
};
